"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCard = ChallengeCard;
Object.defineProperty(exports, "ChallengeCardData", {
  enumerable: true,
  get: function () {
    return _data.ChallengeCardData;
  }
});
Object.defineProperty(exports, "ChallengeCollabationTypeChip", {
  enumerable: true,
  get: function () {
    return _collabationTypeChip.ChallengeCollabationTypeChip;
  }
});
Object.defineProperty(exports, "challengeCollaborationTypesMap", {
  enumerable: true,
  get: function () {
    return _collabationTypeChip.challengeCollaborationTypesMap;
  }
});
exports.defaultChallengesImages = void 0;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _useMediaQuery2 = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _ = require("..");
var _days = _interopRequireDefault(require("../../assets/images/challenges/days.svg"));
var _work = _interopRequireDefault(require("../../assets/images/challenges/work.svg"));
var _hooks = require("../../hooks");
var _collabationTypeChip = require("./collabation-type-chip");
var _data = require("./data");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const defaultChallengesImages = exports.defaultChallengesImages = {
  cyclingDays: _days.default,
  traveledDistance: _work.default,
  homeWorkJourneysCount: _work.default,
  journeysCount: _work.default
};
function ChallengeCard({
  Button: _Button,
  Dialog,
  Link,
  isModel,
  containerProps,
  imagePosition,
  disableLink,
  disableTitle,
  disableDescription,
  enableMembersCount,
  disableProgression,
  enableUserProgression,
  enableProgressionHighlight,
  enableProgressionDescription,
  enableDescriptionLink,
  geogroup,
  challenge,
  userChallenge,
  redirectLink,
  activateButtonDisabled,
  handleActivate,
  handleClick
}) {
  const [photosDialogOpen, openPhotosDialog] = (0, _react.useState)(false);
  const [showedPhotos, showPhotos] = (0, _react.useState)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const theme = (0, _styles.useTheme)();
  const isSmall = (0, _useMediaQuery2.default)(theme.breakpoints.down('md'));
  const {
    getProgressValue
  } = (0, _hooks.useChallenge)();
  function handlePhotosDialogOpen() {
    if (!challenge || !challenge.photo) return;
    showPhotos([{
      url: challenge.photo
    }]);
    openPhotosDialog(true);
  }
  function handlePhotosDialogClose() {
    openPhotosDialog(false);
    setTimeout(() => showPhotos(null), theme.transitions.duration.leavingScreen);
  }
  const imageOnLeft = imagePosition === 'left' && !isSmall;
  const collaborationType = challenge ? _collabationTypeChip.challengeCollaborationTypesMap[challenge.isLocal ? 'local' : challenge.collaborationType === 'teams' ? challenge.subGroupDisplay === 'companySite' ? 'sites' : 'teams' : challenge.collaborationType] || null : undefined;
  const Button = _Button || _.Button;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, _extends({
    bgcolor: "#fff",
    border: "1px solid #e3e7ee",
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    maxWidth: "100%",
    overflow: "hidden"
  }, containerProps), /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    className: "challenge-card",
    component: challenge && !disableLink && !handleActivate && Link || 'div',
    disableRipple: !challenge || disableLink && !handleClick || Boolean(handleActivate),
    onClick: handleClick,
    sx: {
      alignItems: 'stretch',
      cursor: !challenge || disableLink && !handleClick || handleActivate ? 'default' : undefined,
      display: 'flex',
      flexDirection: imageOnLeft ? 'row' : 'column',
      flexGrow: 1,
      maxWidth: '100%',
      overflow: 'hidden',
      textAlign: 'left',
      '.MuiTouchRipple-root': {
        zIndex: 3
      }
    },
    to: redirectLink || (challenge ? challenge.isLocal ? `/challenges/${challenge.id}?group=${challenge.group}` : `/challenges/${challenge.id}` : undefined)
  }, imagePosition !== 'none' && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    sx: {
      ...(handleActivate ? {
        filter: 'grayscale(100%)'
      } : {})
    },
    width: imageOnLeft ? '50%' : '100%'
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    height: imageOnLeft ? '100%' : undefined,
    minHeight: imageOnLeft ? 300 : undefined,
    paddingTop: imageOnLeft ? undefined : '40%',
    position: "relative"
  }, challenge ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    component: disableLink && !isModel && challenge.photo ? _ButtonBase2.default : 'div',
    height: "100%",
    left: 0,
    onClick: () => disableLink && !isModel && challenge.photo && handlePhotosDialogOpen(),
    position: "absolute",
    sx: {
      backgroundImage: `url(${challenge.photo || defaultChallengesImages[challenge.type]})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    },
    top: 0,
    width: "100%",
    zIndex: 1
  }), imageOnLeft && collaborationType && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: collaborationType?.bgColor,
    border: `0 1px 1px 0 solid ${collaborationType?.borderColor}`,
    borderRadius: "0 0 16px 0",
    color: collaborationType?.color,
    display: "flex",
    gap: 1,
    left: 0,
    padding: 1.5,
    position: "absolute",
    top: 0,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement(collaborationType.Icon, {
    color: "inherit",
    fontWeight: 600,
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "inherit",
    fontWeight: 600,
    variant: "body2"
  }, t(collaborationType.labelKey)))) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: "100%",
    sx: {
      left: 0,
      position: 'absolute',
      top: 0
    },
    variant: "rectangular",
    width: "100%"
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3,
    overflow: "hidden",
    padding: 4,
    sx: {
      ...(handleActivate ? {
        bgcolor: '#F6F8FC'
      } : {})
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3,
    sx: {
      ...(handleActivate ? {
        filter: 'grayscale(100%)'
      } : {})
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, !imageOnLeft && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_collabationTypeChip.ChallengeCollabationTypeChip, {
    collaborationType: collaborationType
  }), challenge && 'eventId' in challenge && challenge.eventId && /*#__PURE__*/_react.default.createElement(_.GeoveloIcon, {
    fontSize: "large"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, !disableTitle && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontSize: "1.25rem",
    fontWeight: 600,
    title: challenge?.title
  }, challenge ? challenge.title : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })), !disableDescription && /*#__PURE__*/_react.default.createElement(_Box2.default, null, (!challenge || challenge.description) && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    sx: !disableLink ? {
      display: '-webkit-box',
      WebkitLineClamp: '3',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    } : {},
    variant: "body2"
  }, challenge?.description || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "90%"
  }))), enableDescriptionLink && challenge?.detailsUrl && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    marginTop: 1
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    href: challenge.detailsUrl,
    rel: "noreferrer",
    size: "small",
    startIcon: /*#__PURE__*/_react.default.createElement(_.LinkIcon, null),
    target: "_blank",
    variant: "text"
  }, t('commons.actions.more_informations')))))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: {
      xs: 1,
      md: 2
    }
  }, !isModel ? /*#__PURE__*/_react.default.createElement(_data.ChallengeCardData, {
    Button: Button,
    challenge: challenge,
    Dialog: Dialog,
    disableProgression: disableProgression,
    enableMembersCount: enableMembersCount,
    enableProgressionDescription: enableProgressionDescription,
    enableProgressionHighlight: enableProgressionHighlight,
    enableUserProgression: enableUserProgression,
    geogroup: geogroup,
    userChallenge: userChallenge
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_.CalendarIcon, {
    color: "primary",
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontWeight: 600,
    variant: "body2"
  }, t('commons.periods.month', {
    count: challenge?.endDate.diff(challenge.endDate, 'month')
  }))), (!challenge || challenge.collaborationType === 'global') && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_.CupIcon, {
    color: "primary",
    fontSize: "small"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontWeight: 600,
    variant: "body2"
  }, challenge ? getProgressValue(challenge.type, challenge.targetValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))))), handleActivate && /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: activateButtonDisabled,
    onClick: handleActivate,
    size: "medium",
    startIcon: activateButtonDisabled && /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    variant: "contained"
  }, "Activer ce challenge")))), /*#__PURE__*/_react.default.createElement(_.PhotosDialog, {
    onClose: handlePhotosDialogClose,
    open: photosDialogOpen,
    photos: showedPhotos
  }));
}